import { message } from 'antd'
import { useMutation } from '@tanstack/react-query'
import { adminApi } from '~/api'
import { clipboard } from '~/utils/helpers'

export const useNativeAppstreamLinkMutation = (courseId) =>
  useMutation(
    async (studentId) => {
      const { data } = await adminApi.getNativeAppstreamLink(courseId, studentId)
      return data.data
    },
    {
      onSuccess: (data) => {
        clipboard(data)
        message.success('Copied')
      },
      onError: (error) => {
        message.error(error.response?.data?.message)
      }
    }
  )
